

















































import Vue from "vue";
import {
  DeployModelTemplateDTO,
  IotAppModelTemplateServiceProxy,
  IotAppServiceProxy, IotAppSettingServiceProxy, ListResultVOOfSettingVO,
  PageRequestDTO
} from "@/service-proxies/app-v2/iot-console.service-proxies";
import {
  IotCollectionSettingDTO,
  MachineIotServiceProxy,
  MachineServiceProxy
} from "@/service-proxies/app-v2/workStation.service-proxies";
import {ExtranetSettingServiceProxy} from "@/service-proxies/app-v2/extranet.service-proxies";

const appSrvProxy = new IotAppServiceProxy();
const appTemplateSrvProxy = new IotAppModelTemplateServiceProxy();
const machineSrvProxy = new MachineServiceProxy();
const machineIotSrvProxy = new MachineIotServiceProxy();
const extranetSettingSrvProxy: ExtranetSettingServiceProxy = new ExtranetSettingServiceProxy();
const iotAppSettingProxy = new IotAppSettingServiceProxy();

export default Vue.extend ({
  props: {
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        templateId: [
          { required: true, message: this.$t('page_ops_machine_bind_iot_collection_settings_required'), trigger: 'blur' },
        ],
      },
      loading: false,
      saving: false,
      record:{
      },
      workStationId: undefined,
      gatewayCode: undefined,
      gatewayId: undefined,
      appCode: undefined,
      appId: undefined,
      appList:[],
      templateList:[],
    };
  },
  computed:{
    disTitle() {
      return this.$t('page_ops_machine_bind_iot_edit');
    }
  },
  methods: {
    open(workStationId: string, gatewayCode: string, gatewayId:string, appCode:string,appId:string) {
      this.visible = true;
      this.gatewayCode = gatewayCode;
      this.gatewayId = gatewayId;
      this.appCode = appCode;
      this.appId = appId;
      this.workStationId = workStationId;
      this.record = {
      };

      const templateDto = new PageRequestDTO();
      templateDto.size=-1;
      templateDto.current=-1;
      appTemplateSrvProxy.pageModelTemplate(templateDto)
          .then(res=>{
            this.templateList = res.items;
          });

      this.init();

    },
    appDeviceIp(list:ListResultVOOfSettingVO){
      return list.items.find(c=>c.name==='IpAddress')?.currentValue;
    },
    appDevicePort(list:ListResultVOOfSettingVO){
      return list.items.find(c=>c.name==='TcpPort')?.currentValue;
    },
    async init(){
      this.loading=true;
      try{
        const setting = await extranetSettingSrvProxy.getExtranetSetting();
        const iotAppSettingList:ListResultVOOfSettingVO = await iotAppSettingProxy.getIotAppSettingList(
            this.appCode, this.gatewayCode
        );

        const defaultIp = setting.ip || "192.168.1.101";
        const defaultPort = 49200;

        const machineIot = await machineIotSrvProxy.getDetail(this.workStationId);
        if(machineIot==null){
          this.record.deviceIp = this.appDeviceIp(iotAppSettingList) || defaultIp;
          this.record.devicePort = this.appDevicePort(iotAppSettingList) || defaultPort;
          return;
        }

        this.record = {
          deviceIp: this.appDeviceIp(iotAppSettingList)||defaultIp,
          devicePort: this.appDevicePort(iotAppSettingList)||defaultPort,
          templateId: machineIot.templateId || undefined,
        }
      }
      finally {
        this.loading=false;
      }

    },
    save() {
      this.$refs.bindIotForm.validate(valid => {
        if (valid) {
          this.saving=true;

          const input = new IotCollectionSettingDTO();
          input.appCode=this.appCode;
          input.gatewayCode = this.gatewayCode;
          input.appId=this.appId;
          input.gatewayId = this.gatewayId;
          input.templateId=this.record.templateId;
          input.deviceIp = this.record.deviceIp;
          input.devicePort = this.record.devicePort;
          input.workStationId=this.workStationId;
          machineSrvProxy.iotCollectionSettings(input)
              .then(res=>{
                this.$message.success(this.$t('save_success'));
                this.visible=false;
                this.$emit('save')
                this.record = {}
              })
              .finally(()=>{
                this.saving=false;
              });
        } else {
          return false;
        }
      });
    }
  }
})
